



















import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import InputWithLabel from '@/components/common/atoms/InputWithLabel.vue'
import { StudentData } from '@/mixins/requests/admin/StudentListApis.vue'
import SelectBase, { SelectOption } from '@/components/common/atoms/SelectBase.vue'

@Component({
  components: {
    ButtonBase,
    InputWithLabel,
    SelectBase,
  },
})
export default class StudentForm extends Vue {
  @Prop()
  private studentData!: StudentData
  @Prop()
  private gradeOptions!: SelectOption[]
  @Prop()
  private onClickCancel!: () => void

  private get btnColortype(): string | null {
    return this.validate() ? null : 'disabled'
  }

  private get isCreate(): boolean {
    return !this.studentData.userId
  }

  private validate(): boolean {
    return this.studentData.nickname &&
      this.studentData.gradeId &&
      ((this.isCreate && this.studentData.password && this.studentData.passwordConfirmation) ||
        (!this.isCreate && this.studentData.password && this.studentData.passwordConfirmation) ||
        (!this.isCreate && !this.studentData.password && !this.studentData.passwordConfirmation))
      ? true
      : false
  }

  private save() {
    if (!this.validate()) return
    this.$emit('save')
  }
}
